// extracted by mini-css-extract-plugin
export default {"taskPageHeaderContainer":"TaskPageHeader_taskPageHeaderContainer__nie75"};